export default "__VITE_ASSET__CU_2Tg6K__"